import React, { useState, useRef } from 'react';
import { Search, Button } from 'carbon-components-react';
import { Search16 } from '@carbon/icons-react';
import { zoomToCenter } from 'components/Map/helper';

const parseAndValidateCoordinate = (value: string) => {
  const coordinateArr = value.split(',');
  if (
    coordinateArr.length === 2 &&
    /^-?\d+(\.\d{1,})?$/.test(coordinateArr[0].trim()) &&
    /^-?\d+(\.\d{1,})?$/.test(coordinateArr[1].trim())
  ) {
    const lat = Number(coordinateArr[0].trim());
    const lon = Number(coordinateArr[1].trim());
    let isValidCoordinate = true;

    if (
      Number.isNaN(lat) ||
      Number.isNaN(lon) ||
      lat === 0 ||
      lon === 0 ||
      lat < -90 ||
      lat > 90 ||
      lon < -180 ||
      lon > 180
    ) {
      isValidCoordinate = false;
    }

    return { lat, lon, isValidCoordinate };
  }

  return { lat: NaN, lon: NaN, isValidCoordinate: false };
};

const LatLongSearch: React.FC<Props> = ({ onClose }) => {
  const [searchInputValue, setSearchInputValue] = useState<string>('');
  const [searchInvalid, setSearchInvalid] = useState<boolean>(false);

  const searchButtonRef = useRef<HTMLButtonElement>(null);

  const handleInputChange = (value: string) => {
    if (!value) {
      setSearchInvalid(false);
    }
    setSearchInputValue(value);
  };

  const searchCoordinate = (evt: React.MouseEvent) => {
    evt.preventDefault();
    evt.stopPropagation();

    const searchButtonElem = searchButtonRef?.current;
    searchButtonElem && searchButtonElem.blur();

    const { lat, lon, isValidCoordinate } =
      parseAndValidateCoordinate(searchInputValue);
    if (!isValidCoordinate) {
      setSearchInvalid(true);
    } else {
      setSearchInvalid(false);
      const center = [lon, lat];
      zoomToCenter(center, searchInputValue);
      onClose();
    }
  };

  return (
    <div className="lat-long-input-container">
      <div className="bx--form-item">
        <label className="bx--label">LAT, LONG SEARCH</label>
        <Search
          id="lat-long-input"
          size="xl"
          labelText="LAT, LONG SEARCH"
          onChange={(evt) => handleInputChange(evt.target.value)}
          value={searchInputValue}
          className={searchInvalid ? 'invalid' : undefined}
        />
      </div>
      <Button
        className="lat-long-search-button"
        renderIcon={Search16}
        hasIconOnly
        kind="tertiary"
        iconDescription="Search coordinate"
        tooltipPosition="right"
        onClick={searchCoordinate}
        disabled={!searchInputValue}
        ref={searchButtonRef}
      />
    </div>
  );
};

type Props = {
  onClose: Function;
};

export default React.memo(LatLongSearch);
